import React from 'react'
import { CalendarMonth, Factory, Folder, Handyman, HeadsetMic, SmartToy, Speed } from '@mui/icons-material'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import ProductsConstellation from './decorations/ProductsConstellation'

const SOLUTIONS_BASE_URL = 'https://smartpm.es/soluciones/'

/**
 * Grid of MIC products, each card linking to its section on the SMARTPM website
 * (HU-03) — never to the module inside the app, which this story leaves out of
 * scope. Product names are brand and stay untranslated; only the claims localise.
 *
 * The list is built inside the component, with literal `t_()` calls, so the
 * translation scanner can still collect the keys.
 */
const ProductsSection = () => {
  const { t_ } = useSmartTranslation()

  const products = [
    { id: 'repository', name: t_('Repository'), page: 'mic-repositorio-digital.html', claim: t_('Documentation always at hand'), icon: <Folder /> },
    { id: 'planner', name: 'MIC Planner', page: 'mic-planificador.html', claim: t_('Plan and schedule'), icon: <CalendarMonth /> },
    { id: 'mos', name: 'MOS', page: 'mic-sistema-operaciones.html', claim: t_('Shop floor operations'), icon: <Factory /> },
    { id: 'monitoring', name: 'MIC Monitoring', page: 'mic-monitorizacion.html', claim: t_('Watch every indicator'), icon: <Speed /> },
    { id: 'toolManager', name: 'MIC Tool Manager', page: 'mic-tool-manager.html', claim: t_('Manage your tools'), icon: <Handyman /> },
    { id: 'automation', name: 'MIC Automation System', page: 'mic-sistemas-automatizacion.html', claim: t_('Automate your processes'), icon: <SmartToy /> },
    { id: 'serviceHub', name: 'MIC Service Hub', page: 'hub-servicios.html', claim: t_('Support and tickets'), icon: <HeadsetMic /> }
  ]

  return (
    <section className='mic-home-products'>
      <ProductsConstellation />
      <h2 className='mic-home-eyebrow'>{t_('Explore the MIC products on our website')}</h2>
      <div className='mic-home-product-grid'>
        {products.map((product) => (
          <a
            className='mic-home-product-card'
            key={product.id}
            href={SOLUTIONS_BASE_URL + product.page}
            target='_blank'
            rel='noopener noreferrer'
          >
            <span className='mic-home-product-icon'>{product.icon}</span>
            <div>
              <div className='mic-home-product-name'>{product.name}</div>
              <div className='mic-home-product-claim'>{product.claim}</div>
            </div>
          </a>
        ))}
      </div>
    </section>
  )
}

export default ProductsSection
